import RoundedTable from './RoundedTable';
// import './RoundedTable.css';
import './ListTable.css';

export default RoundedTable;



// WEBPACK FOOTER //
// ./src/shared/components/RoundedTable/index.js